/**
 * Accept-Language ヘッダーからロケールを推定します。
 * ログイン前にデフォルト表示を切り替えたい場合に利用します。
 *
 * 例:
 *   "ja-JP,ja;q=0.9,en-US;q=0.8,en;q=0.7" → "ja"
 *   "en-US,en;q=0.9" → "en"
 *   undefined → "ja"（デフォルト）
 */
export const parseAcceptLanguage = (acceptLanguageHeader?: string): string => {
  const acceptLang = acceptLanguageHeader ?? "";
  return acceptLang.split(",")[0]?.split("-")[0] || "ja";
};
